// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-2zbUi"};